// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1c07e706] .v-tab {\n  text-transform: initial;\n}\n[data-v-1c07e706] .v-slide-group__prev {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
